import {
  Button,
  CircularProgress,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { CustomColor, CustomTheme } from "../../types/customTheme";

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    root: {
        borderRadius: 10,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "6px 12px",
        minWidth: 40,
        backgroundColor: ({ color }: { color: CustomColor }) =>
          theme.palette.custom[color].main,
        "&:hover": {
          backgroundColor: ({ color }: { color: CustomColor }) =>
            theme.palette.custom[color].dark,
        },
        color: ({ color }: { color: CustomColor }) =>
          theme.palette.custom[color].contrastText,
        textTransform: "none",
    },
  }),
);

export interface ButtonCommonProps {
  onClick?: any;
  color?: CustomColor;
  type?: any;
  [propName: string]: any;
  isLoadingPage?: any
  size?: any
  isDisabled?: any
}

/* This component shows the button with loading. */
const ButtonCommon: React.FunctionComponent<ButtonCommonProps> = ({
  onClick,
  color = "yellow",
  type,
  children,
  isLoadingPage,
  isDisabled = false,
  size = "large",
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles({ color });

  const handleClick = async (event?: React.MouseEvent<HTMLButtonElement>) => {
    if (!onClick) return;

    try {
      setIsLoading(true);
      await onClick(event);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      className={classes.root}
      disableElevation
      onClick={handleClick}
      type={type}
      disabled={isDisabled || isLoading || isLoadingPage}
      size={size}
      {...props}
    >
      {(isLoading || isLoadingPage) ? (
        <CircularProgress color="inherit" size={20} />
      ) : (
        children
      )}
    </Button>
  );
};

export default ButtonCommon;
